import { render, staticRenderFns } from "./clients-deletion.vue?vue&type=template&id=dd6eda3e"
import script from "./clients-deletion.vue?vue&type=script&lang=js"
export * from "./clients-deletion.vue?vue&type=script&lang=js"
import style0 from "./clients-deletion.vue?vue&type=style&index=0&id=dd6eda3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports